import { render, staticRenderFns } from "./ModalErrosValidacao.vue?vue&type=template&id=56b0cca4"
import script from "./ModalErrosValidacao.vue?vue&type=script&lang=ts"
export * from "./ModalErrosValidacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports